'use client'

import { useContext } from 'react'
import { useStore } from 'zustand'
import { NotebookStoreContext } from './notebook-store-context'
import { getNotebookStoreApi, tryGetNotebookStoreApi } from './notebook-store-api'

function resolveStoreApi() {
  const contextStore = useContext(NotebookStoreContext)
  if (contextStore) return contextStore
  return getNotebookStoreApi()
}

function resolveStoreApiForImperative() {
  const api = tryGetNotebookStoreApi()
  if (api) return api
  return getNotebookStoreApi()
}

export function useNotebook(selector, equalityFn) {
  const api = resolveStoreApi()
  if (typeof selector === 'function') {
    return useStore(api, selector, equalityFn)
  }
  return useStore(api)
}

useNotebook.getState = () => {
  const api = tryGetNotebookStoreApi()
  if (!api) {
    throw new Error(
      'Notebook store is not mounted. Use NotebookStoreProvider on /notebook/[id] routes.',
    )
  }
  return api.getState()
}

useNotebook.setState = (...args) => resolveStoreApiForImperative().setState(...args)

/** Safe for useSyncExternalStore — no throw when Activity pauses the route. */
useNotebook.subscribe = (listener) => {
  const api = tryGetNotebookStoreApi()
  if (!api) return () => {}
  return api.subscribe(listener)
}
